import {
  ModalLayout,
  Pagination,
  SearchFilters,
  // Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import useAssignedTable from "./useAssignedTable";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../OrderColumn";
import RemarksTable from "../../RemarksTable";
import{Table} from "../../../Global/Table";

const AssignedTable = () => {
  const {
    isLoading,
    staffState,
    isFetching,
    tableFields,
    showEditModal,
    globalRemarkModal,
    assignedTableData,
    paginationOptions,
    getRow,
    refetch,
    handlePageSize,
    handleModalClose,
    handlePagination,
    updateAssignedFields,
    handleEditColumnsClick,
    handleSearch,
  } = useAssignedTable();
  return (
    <div>
      <SearchFilters
        onSearchInput={handleSearch}
        SearchIcon={<span className="material-symbols-outlined"> search </span>}
        showClearFilters={false}
        searchInputProps={{ value: staffState?.assignedSearch, placeholder: "Search Certificate Number" }}
        isLoading={isLoading}
        showActions={true}
        handleActionClick={handleEditColumnsClick}
      />
      <Table
        multiSelect={false}
        data={assignedTableData?.data?.data ?? []}
        uniqueID={"id"}
        fields={tableFields}
        SortIcon={<FaSort />}
        assignIcon={<span className="material-symbols-outlined">badge</span>}
        getRow={getRow}
        loading={isFetching}
        perpage={staffState?.currentPageSize}
        assignable={false}
        deletable={false}
        editable={false}
        showCheckBox={false}
      />
      <Pagination
        currentPage={staffState?.currentPageTab}
        totalPageCount={Math.ceil(
          assignedTableData?.data?.total_count /
            assignedTableData?.data?.per_page
        )}
        onPageChange={handlePagination}
        options={paginationOptions}
        onActionChange={handlePageSize}
        center
      />
      <ModalLayout show={showEditModal} handleClose={handleEditColumnsClick}>
        <div className="pro-m-5">
          <OrderColumn
            title={"Choose which columns you see"}
            refetchData={refetch}
            tableFields={assignedTableData?.data?.fields}
            moduleId={assignedTableData?.data?.module_id}
            updateData={updateAssignedFields}
          />
        </div>
      </ModalLayout>
      <ModalLayout
        show={globalRemarkModal}
        handleClose={handleModalClose}
        title={"Remarks"}
        propStyle={{root : 'pro-modal-xxl'}}
        closeIcon={<span className="material-symbols-outlined">close</span>}
      >
        <div className="pro-m-5">
          <RemarksTable />
        </div>
      </ModalLayout>
    </div>
  );
};

export default AssignedTable;
